import { tokens } from "@swiggy-private/dls-web-common/dist/components/tokens";

export const EXPRIRING_SAVINGS_TEXTS = {
    MESSAGE: "(expires in {0} days)",
    TOOLTIP_CONTENT: "off on next order",
    TOOLTIP_BODY: "This discount will get applied automatically when you order again within {0} days.",
};

export const COUPON_CARD_CTA_TEXTS = {
    MORE: "+ MORE",
    APPLY: "APPLY",
};

export const INPUT_BOX_PLACEHOLDER = "Enter Coupon Code";

export const DOUBLE_OFFER_COUPON_TYPE = "COUPON_TYPE_DOUBLE_OFFER";

export const APPLYING_COUPON_LOADER_TEXT = "Applying Coupon";
export const REMOVING_COUPON_LOADER_TEXT = "Removing Coupon";

export const COUPONLISTING_BOTTOMSHEET_CTA = "Back";
export const PAYMENT_COUPONLISTING_BOTTOMSHEET_CTA = "Don’t Apply this Coupon";
export const UNLOCK = "Unlock";

export const TD_COUPON_MODAL = {
    TD_COUPON_MODAL: "tdCouponModal",
    VALUE_MEALS: {
        TITLE: `<span style='color: ${tokens.colors.green1};'><span style="font-weight: 600;">Value Meals</span></span>`,
        SUBTEXT: "savings on this order",
    },
};

export const COUPON_CARD_GROUP_NEW_LOTTIE_MAXLIMIT = 15;

import { DialogButtonTypes } from "@swiggy-private/native-bridge";
export enum BUTTON_IDS {
    YES = "1",
    NO = "2",
}

export const RemoveCouponModalData = {
    message: "Are you sure you want to remove the applied coupon?",
    buttonLabels: [
        {
            id: BUTTON_IDS.YES,
            text: "Yes",
            type: DialogButtonTypes.PRIMARY,
        },
        {
            id: BUTTON_IDS.NO,
            text: "No",
            type: DialogButtonTypes.SECONDARY,
        },
    ],
};

export const confettiMapping = {
    CONFETTI_TYPE_TOP_UP: "TOP_UP_COUPON",
    CONFETTI_TYPE_AUTO_APPLY: "AUTO_APPLY_COUPON",
};

export const SWIGGY_ONE_CONFETTI = "APPLY_SWIGGY_ONE";
export const SWIGGY_BLACK_CONFETTI = "APPLY_SWIGGY_BLACK";

export const SAVINGS_BANNER_YAY = "CartPageAssets/SavingsBannerYay";

export const ERROR_TEXT = {
    DEFAULT: "Oops, something is wrong",
    TRY_THIS: "Try this instead",
    CONSIDER_THIS: "Consider this instead",
};

export const CART_RELOAD_TIME_REDIRECTION_MS = 60000;

export const APPLY_COUPON_TEXTS = {
    TITLE: "APPLY COUPON",
    SUB_TITLE: "Your cart: \u20B9{0}",

    // Cart 2.0 constants
    VIEW_ALL_COUPONS: "View all coupons",
    ADD_ITEM: "Add Item",
    SAVE_ON_ORDER_WITH_EXTRA_SAVINGS: "Save {0} on this order + extra {1} on next order",
    SAVE_ON_ORDER: "Save {0} on this order",
    APPLY: "Apply",
    SAVE_ANOTHER_X_WITH_COUPON: "Save another {0} with {1}",
    SAVE_X_WITH_COUPON: "Save {0} with {1}",
    APPLY_COUPON: "Apply Coupon",
    X_APPLIED: "'{0}' applied",
    X_SAVED_WITH_COUPON: "{0} saved with {1}",
    UNLOCK_COUPON_WITH_X: "Unlock {0} with items worth {1}",
    X_OFF_ON_NEXT_ORDER: "{0} off on next order",
    EXPIRES_IN_DAYS: "Expires in {0} days",
    EXTRA_SAVINGS_TOOLTIP_CONTENT: "This discount will get applied automatically when you order again within {0} days.",
    X_SAVED_WITH_BENEFIT: "{0} saved with '{1}'",
    APPLIED: "Applied",
    ENDS_IN: "Ends in {0}",
};

export const EMPTY_COUPON_PAGE_TITLE = "No Offers";
export const EMPTY_COUPON_PAGE_SUBTITLE = "Exciting new offers are coming your way!";

export const CROUTON_IMG = "CancellationPolicyAssets/arrow_crouton67_5x";

export const COUPON_CROUTON_TEXT = "View Add-On {0}";

export const SAVINGS_COUPON = "savings-coupon";

const COUPON_CARD = "coupon_card";
const COUPON_CARD_GROUP = "coupon_card_group";

const COUPON_ERROR_BOTTOM_SHEET = "coupon_error_bs";
const APPLY_COUPON_INPUT_BOX_PREFIX = "apply-coupon-input-box";

export const COUPON_CARD_TESTS_IDS = {
    CONTAINER: `${COUPON_CARD}_container`,
    APPLY_CTA: `${COUPON_CARD}_apply_cta`,
    GROUP_TITLE: `${COUPON_CARD}_group_title`,
    FOOTER_IMAGE: `${COUPON_CARD}_footer_image`,
};

export const COUPON_CARD_GROUP_TESTS_IDS = {
    NEW_INDICATOR: `${COUPON_CARD_GROUP}_new_tag`,
};

export const COUPON_LISTING_SHIMMER_CONTAINER_TEST_ID = "coupon-listing-shimmer-container";

export const COUPON_ERROR_BOTTOM_SHEET_TEST_IDS = {
    LOADER: `${COUPON_ERROR_BOTTOM_SHEET}_loader`,
    TITLE: `${COUPON_ERROR_BOTTOM_SHEET}_title`,
    CONTAINER: `${COUPON_ERROR_BOTTOM_SHEET}_container`,
    FULL_WIDTH_CTA: `${COUPON_ERROR_BOTTOM_SHEET}_full_width_cta`,
};

export const DELIGHT_POPUP_TEST_IDS = {
    POPUP: "auto-applied-delight-popup",
};

export const APPLY_COUPON_INPUT_BOX_DATA_TEST_ID = {
    CONTAINER: `${APPLY_COUPON_INPUT_BOX_PREFIX}-container`,
    INPUT: `${APPLY_COUPON_INPUT_BOX_PREFIX}-input`,
};
